<div class="login-page">
  <div class="container d-flex align-items-center">
    <div class="form-holder has-shadow">
      <div class="row">
        <div class="col-lg-6">
          <div class="info d-flex align-items-center bg-danger">
            <div class="content">
              <div class="logo">
                <h1>Heypogi</h1>
              </div>
              <p>Checking your account</p>
            </div>
          </div>
        </div>
        <!-- Form Panel    -->
        <div class="col-lg-6 bg-white">
          <div class="form d-flex align-items-center">
            <div class="content">
              {{ info }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
